const en = {
  common: {
    back: 'Back',
    continue: 'Continue',
    loading: 'Loading…',
    powered_by: 'Powered by',
    try_again: 'Try again',
    download_pdf: 'Download PDF',
    close: 'Close',
  },
  nav: {
    gift_vouchers: 'Gift vouchers',
    check_voucher: 'Check a voucher',
  },
  legal: {
    terms: 'Terms & conditions',
    privacy: 'Privacy statement',
    company_details: 'Company details',
    vat: 'VAT',
    back_to_shop: 'Back to the shop',
    loading: 'Loading…',
    error: 'This document could not be loaded.',
  },
  card: {
    gift_voucher: 'Gift voucher',
    number: 'No. {serial}',
    value: 'Value',
    voucher_code: 'Voucher code',
    quote_code: 'Quote this code when you book or on arrival.',
    valid_until: 'Valid until',
    terms: 'Not exchangeable for cash. Redeemable in one or more visits.',
    remaining: '{amount} remaining',
    code_placeholder: '••••••••',
  },
  shop: {
    title: 'A table, waiting for someone.',
    intro:
      'Choose an amount or a set menu. It arrives by email within a minute, with your message on it, and is good for twelve months.',
    choose_amount: 'Choose an amount',
    see_menus: 'See set menus',
    fact_instant: 'Instant delivery',
    fact_message: 'Personal message',
    fact_valid: 'Valid 12 months',
    amounts_heading: 'Choose an amount',
    amounts_aside: 'Any amount from {amount}',
    other_amount: 'Other',
    continue_with: 'Continue · {amount}',
    error_choose_amount: 'Choose an amount first.',
    error_minimum: 'The smallest voucher is {amount}.',
    error_maximum: 'The largest voucher is {amount}.',
    menus_heading: 'Or give an evening',
    menus_aside: 'Set menus and packages',
    select: 'Select',
    receive_heading: 'What they receive',
    receive_aside: 'Email, print or wallet',
    fact_delivery_label: 'Delivery',
    fact_delivery_body: 'By email within a minute, or on a printed sheet you can hand over yourself.',
    fact_validity_label: 'Validity',
    fact_validity_body: 'Twelve months from purchase, spent across one or more visits.',
    fact_redeeming_label: 'Redeeming',
    fact_redeeming_body: 'Quote the code when booking, or show it on arrival. Nothing to print.',
    empty: 'This shop has no vouchers on sale yet. Please check back soon.',
    loading: 'Loading shop…',
    unavailable_title: 'Shop unavailable',
    error_disabled: 'This gift voucher shop is not available for this location.',
    error_not_found: 'Location not found.',
    error_generic: 'Failed to load the shop. Please try again later.',
  },
  purchase: {
    step: 'Step 1 of 2 — details',
    title: 'Who is it for?',
    subtitle: "We'll email the voucher to them, or to you if you'd rather hand it over yourself.",
    first_name: 'First name',
    last_name: 'Last name',
    their_email: 'Their email',
    your_name: 'Your name',
    your_email: 'Your email',
    message: 'Message',
    message_hint: 'optional, printed on the voucher',
    delivery: 'Delivery',
    delivery_email: 'Email it to them',
    delivery_email_hint: 'Arrives within a minute',
    delivery_self: 'Send it to me',
    delivery_self_hint: 'You hand it over yourself',
    delivery_print: 'Print at home',
    delivery_print_hint: 'A PDF you can print',
    next: 'Next: payment',
    error_recipient_name: "Please fill in the recipient's name.",
    error_recipient_email: 'Please enter a valid email address for the recipient.',
    error_your_name: 'Please fill in your name.',
    error_your_email: 'Please enter a valid email address for yourself.',
    error_title: 'Something went wrong',
    error_body: 'This voucher could not be loaded.',
    error_no_amount: 'No amount chosen. Please start again from the shop.',
    error_package_gone: 'This package is no longer available.',
    error_product_gone: 'This voucher is no longer available.',
    error_load: 'Failed to load. Please try again later.',
    back_to_shop: 'Back to the shop',
  },
  order: {
    heading: 'Your order',
    gift_voucher: 'Gift voucher',
    delivery: 'Delivery',
    delivery_email: 'Email',
    delivery_print: 'Print at home',
    delivery_self: 'To you',
    for: 'For',
    total: 'Total',
    note_validity: 'Valid twelve months from purchase, spent across one or more visits.',
    note_refund: 'Valid twelve months from purchase. Refundable within fourteen days while unused.',
  },
  buyer: {
    buying_as: 'Buying as',
    private: 'Private person',
    company: 'Company',
    company_helper: "You'll receive a purchase confirmation with your company details for your accounting. Gift vouchers are sold without VAT; VAT is charged when the voucher is used at the restaurant.",
    how_it_works: 'How does this work?',
  },
  companyDetails: {
    legal_name: 'Company name (legal)',
    vat_number: 'VAT number',
    registration_number: 'Company registration no.',
    street: 'Street and number',
    postal_code: 'Postal code',
    city: 'City',
    country: 'Country',
    billing_email: 'Billing email',
    po_reference: 'Purchase order / reference',
    optional: 'optional',
    recommended: 'optional, recommended',
    registration_hint_be: 'KBO / enterprise number',
    registration_hint_nl: 'KvK number',
    error_required: 'Required',
    error_email: 'Enter a valid email address',
    error_vat: 'This VAT number does not look right. Check the country code and the digits.',
    error_country: 'Choose a country',
    error_invalid: 'Check this field',
    error_fix: 'Please complete your company details.',
    eyebrow: 'Purchase confirmation',
    page_title: 'Add your company details',
    page_intro: "Add your company's details and we'll send you a new version of your purchase confirmation with them on it, for your accounting.",
    order_heading: 'Your order',
    merchant: 'Restaurant',
    document_number: 'Document no.',
    issued_at: 'Date',
    amount: 'Amount',
    vat_note: 'Gift vouchers are sold without VAT; VAT is charged when the voucher is used at the restaurant.',
    submit: 'Send updated confirmation',
    submitting: 'Sending…',
    submit_error: 'Your details could not be saved. Please try again.',
    load_error: 'This page could not be loaded. Please try again later.',
    done_badge: 'Saved',
    done_body: 'Done. A new version of your purchase confirmation ({number}) was sent to {email}.',
    done_body_no_email: 'Done. A new version of your purchase confirmation ({number}) has been created.',
    not_found_title: 'This link is not valid',
    not_found_body: 'Open the full link from your email, or contact the restaurant.',
    reason_already_used_title: 'Company details already added',
    reason_already_used_body: 'Company details can be added to a purchase confirmation only once. Contact the restaurant if something needs to change.',
    reason_expired_title: 'This link has expired',
    reason_expired_body: 'Company details can only be added for a limited time after the purchase. Contact the restaurant if you still need them.',
    reason_cancelled_title: 'This order was cancelled',
    reason_cancelled_body: 'The voucher on this order has been cancelled, so its purchase confirmation can no longer be changed.',
    reason_not_private_title: 'Your company details are already on it',
    reason_not_private_body: 'This order was placed as a company, so the purchase confirmation already carries your company details.',
    reason_no_document_title: 'Your purchase confirmation is not ready yet',
    reason_no_document_body: 'Please open this link again in a few minutes.',
    reason_generic_title: 'This order cannot be changed',
    reason_generic_body: 'Contact the restaurant and they will help you.',
  },
  checkout: {
    step: 'Step 2 of 2 — payment',
    title: 'Payment',
    subtitle: 'Handled by our payment provider. We never see your card details.',
    pay: 'Pay {amount}',
    opening: 'Opening payment…',
    terms: 'By paying you accept the voucher terms. Your payment is handled securely by our payment provider.',
    confirming: 'Confirming your payment…',
    expired_title: 'Checkout expired',
    expired_body: 'Please start again from the shop.',
    start_over: 'Start over',
    error_missing_data: 'Checkout data is missing. Please start over.',
    error_no_location: 'Unable to determine location. Please start again from the shop page.',
    error_no_url: 'No payment URL received from the server. Please contact the restaurant.',
    error_generic: 'Failed to process the payment. Please try again.',
    provider_loading: 'Fetching the payment methods available for this voucher.',
    provider_verifying: 'Your payment is being processed. The voucher is sent as soon as it is confirmed.',
    provider_failed:
      'The payment provider did not respond. Nothing has been charged — try again, or contact the restaurant if this keeps happening.',
  },
  hosted: {
    eyebrow: 'Payment',
    title_open: 'Finish paying {amount}',
    title_closed: 'The payment window was closed',
    title_blocked: 'Your browser blocked the payment window',
    body_open: '{provider} has opened in a separate window. Once you have paid, this page continues on its own.',
    body_closed:
      'Reopen it to finish, or pay in this tab instead. If you already paid, don’t pay again: this page moves on as soon as we receive it.',
    body_blocked: 'Open {provider} to complete your payment. Nothing has been charged yet.',
    waiting: 'Waiting for your payment…',
    open_provider: 'Open {provider}',
    bring_back: 'Bring the window back',
    pay_here: 'Pay in this tab instead',
    cancel: 'Cancel payment',
    provider_fallback: 'our payment provider',
  },
  success: {
    paid: 'Paid',
    title: 'Sent to {name}',
    title_generic: 'Your voucher is ready',
    copy_to_buyer: 'A copy is on its way to {email} too. ',
    voucher_line: 'Voucher {code}, valid until {date}.',
    send_again: 'Send again',
    sent_again: 'Sent again',
    resend_failed: 'We could not send it again just now. The first email is already on its way.',
    what_happens: 'What happens now',
    emailed_to: 'The voucher has been emailed to {email}. ',
    ready_to_hand_over: 'The voucher is ready to hand over. ',
    spend_note: 'It can be spent across one or more visits until its value runs out.',
    confirming: 'Confirming your payment…',
    error_title: 'We could not show your voucher',
    error_body: 'Please contact the restaurant and we will sort it out.',
    error_status: 'This payment came back as {status}. Nothing has been charged.',
    error_review:
      'We received your payment but could not issue the voucher automatically. The restaurant has been notified and will contact you.',
    error_pending:
      'Your payment is still being confirmed. The voucher will arrive by email — contact the restaurant if it does not.',
    error_load: 'Failed to load the voucher. Please contact the restaurant.',
    purchase_confirmation_download: 'Download purchase confirmation (PDF)',
    purchase_confirmation_preparing: 'Preparing your purchase confirmation…',
    purchase_confirmation_failed: 'Your purchase confirmation is not ready yet. Please try again in a minute.',
    purchase_confirmation_no_vat: 'The purchase confirmation shows no VAT: gift vouchers are sold without VAT, and VAT is charged when the voucher is used.',
  },
  voucher: {
    check_label: 'Check a voucher',
    enter_title: 'Enter your voucher code',
    enter_body: 'It is the eight-character code printed on the voucher and in the email.',
    view: 'View',
    looking_up: 'Looking up your voucher…',
    not_found: 'We could not find that voucher.',
    not_found_body: 'Check the code and try again — it is printed on the voucher and in the email.',
    try_another: 'Try another code',
    load_failed: 'Failed to load the voucher. Please try again.',
    your_voucher: 'Your voucher',
    status_active: 'Active',
    status_expired: 'Expired',
    status_cancelled: 'Cancelled',
    status_spent: 'Fully spent',
    original_value: 'Original value',
    remaining: 'Remaining',
    already_spent: 'Already spent',
    book_table: 'Book a table',
    book_with_voucher: 'Book a table with this voucher',
    book_with_voucher_hint: 'Your voucher is added to the booking automatically.',
    copy_code: 'Copy code',
    copied: 'Copied',
    footer_note: 'Quote this code when you book, or show this page on arrival. Valid until {date}.',
  },
  wallet: {
    apple: 'Add to Apple Wallet',
    google: 'Add to Google Wallet',
    code_required: 'A voucher code is required',
    opening_apple: 'Opening Apple Wallet…',
    opening_google: 'Opening Google Wallet…',
    apple_failed: 'Could not add the voucher to Apple Wallet',
    google_failed: 'Could not add the voucher to Google Wallet',
  },
  cancel: {
    eyebrow: 'Payment',
    title: 'Payment cancelled',
    body: 'Nothing has been charged. Your details are still here, so you can pick up where you left off.',
    go_back: 'Go back',
  },
  home: {
    eyebrow: 'Gift vouchers',
    title: 'A table, waiting for someone.',
    body: 'Gift vouchers are sold by each restaurant on its own page. If you already hold one, you can check its balance here.',
  },
  pdf: {
    gift_voucher: 'GIFT VOUCHER',
    value: 'VALUE',
    voucher_code: 'VOUCHER CODE',
    quote_code: 'Quote this code when you book or on arrival.',
    valid_until: 'VALID UNTIL',
    terms: 'Not exchangeable for cash. Redeemable in one or more visits.',
    for: 'For {name}',
    terms_line_1: 'Present this voucher, or quote its code, when booking or on arrival.',
    terms_line_2: 'The voucher may be spent across one or more visits until its value runs out.',
    terms_line_3: 'It is not exchangeable for cash.',
  },
};

export default en;
